import { render } from "./WirepasFleetHealthGrid.vue?vue&type=template&id=cefd4010&scoped=true&ts=true"
import script from "./WirepasFleetHealthGrid.vue?vue&type=script&lang=ts"
export * from "./WirepasFleetHealthGrid.vue?vue&type=script&lang=ts"

import "./WirepasFleetHealthGrid.vue?vue&type=style&index=0&id=cefd4010&scoped=true&lang=scss"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-cefd4010"]])

export default __exports__